import {Controller, useFormContext} from "react-hook-form";
import {Button, FormControl, FormHelperText, FormLabel, ToggleButtonGroup} from "@mui/joy";

export function FormMultipleOptions({name, label, options}) {
  const form = useFormContext();
  const errors = form.formState.errors;

  return (
    <FormControl error={!!errors[name]}>
      <FormLabel>{label}</FormLabel>
      <Controller
        name={name}
        control={form.control}
        render={({field: {ref, value, onChange}}) => {
          return (
            <ToggleButtonGroup ref={ref} value={value} onChange={(_, newValue) => onChange(newValue)} variant="soft" color="neutral" spacing={1} sx={{
              flexWrap: 'wrap',
              gap: 1,
            }}>
              {options.map((option) => (
                <Button
                  key={option.value}
                  value={option.value}                  
                  sx={{py: 1, px: 2, fontWeight: '500'}}
                >
                  {option.label}
                </Button>
              ))}
            </ToggleButtonGroup>
          );
        }}
      />
      {errors[name] && <FormHelperText>{errors[name].message}</FormHelperText>}
    </FormControl>
  );
}